<form [formGroup]="formGroup()">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
    <div class="flex flex-col gap-2">
      <label for="citizenship" appRequiredLabel="panstwo">Nazwa państwa</label>
      <p-select
        id="citizenship"
        inputId="citizenship"
        appControlError
        [options]="panstwa()"
        [formControl]="formGroup().controls.panstwo"
        optionLabel="nazwa"
        placeholder="Wybierz państwo"
        class="w-full"
        appendTo="body"
        dataKey="kod"
        [filter]="true"
        filterBy="nazwa"
        filterPlaceholder="Wyszukaj państwo"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="gmina" appRequiredLabel="gminaDzielnica"
        >Gmina/Dzielnica</label
      >
      <input
        id="gmina"
        pInputText
        appControlError
        [formControl]="formGroup()!.controls.gminaDzielnica"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="miejscowosc" appRequiredLabel="miejscowosc"
        >Miejscowość</label
      >
      <input
        id="miejscowosc"
        pInputText
        appControlError
        [formControl]="formGroup()!.controls.miejscowosc"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="ulica" appRequiredLabel="ulica">Ulica</label>
      <input
        id="ulica"
        pInputText
        appControlError
        [formControl]="formGroup()!.controls.ulica"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="numerDomu" appRequiredLabel="nrDomu">Numer domu</label>
      <input
        id="numerDomu"
        pInputText
        appControlError
        [formControl]="formGroup().controls.nrDomu"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="numerLokalu" appRequiredLabel="nrLokalu">Numer lokalu</label>
      <input
        id="numerLokalu"
        pInputText
        appControlError
        [formControl]="formGroup().controls.nrLokalu"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label
        for="zagranicznyKodPocztowy"
        appRequiredLabel="kodPocztowyZagraniczny"
        >Zagraniczny kod pocztowy</label
      >
      <input
        id="zagranicznyKodPocztowy"
        pInputText
        appControlError
        [formControl]="formGroup().controls.kodPocztowyZagraniczny"
        [maxlength]="12"
      />
    </div>
  </div>
</form>
